module.exports = "<app-header class=\"header desktop\"></app-header>\r\n\r\n<div style=\"overflow-x:hidden;\">\r\n  <router-outlet></router-outlet>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/mybrokenwalls/workspace/mybrokenwalls/portfolio/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main